import { CrossIcon } from "@/components/Icons/CrossIcon";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from "@/components/ui/alert-dialog";

type SignupExitModalProps = {
  isOpen: boolean;
  onSubmit: () => void;
  onClose: () => void;
};

export const SignupExitModal: React.FC<SignupExitModalProps> = ({ isOpen, onSubmit, onClose }) => {
  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent className="p-0">
        <AlertDialogHeader className="flex flex-row items-start p-5">
          <AlertDialogTitle className="title-h5 text-center">
            Are you sure you want to quit setting up an account process?
          </AlertDialogTitle>
          <CrossIcon
            onClick={onClose}
            className="!mt-0 h-[24px] cursor-pointer text-gray-dark-1000 transition-all hover:text-white"
          />
        </AlertDialogHeader>
        <AlertDialogFooter className="items-center rounded-b-lg border-t bg-black px-5 py-3">
          <AlertDialogAction
            onClick={onClose}
            className="border border-gray-dark-900 bg-gray-dark-600 text-white transition-all hover:bg-white hover:text-black"
          >
            Go Back
          </AlertDialogAction>
          <AlertDialogAction
            onClick={onSubmit}
            className="bg-red-dark-100 text-red-light-500 hover:bg-red-light-500 hover:text-red-dark-100"
          >
            Yes, Quit
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
